<template>
    <b-col lg="3" class="pr-5" >
        <b-form-group v-if="showPerPageSelect"
                label="Éléments par page"
                label-cols-lg="auto"
                label-align="left"
                label-size="md"
                label-for="perPageSelect"
                class="mb-0"
        >
            <b-form-select
                    v-model="val"
                    id="perPageSelect"
                    size="sm"
                    :options="[5, 10, 15]"
            ></b-form-select>
        </b-form-group>
    </b-col>
</template>

<script>
    export default {
        name: 'TablePerPageSelect',
        props: {
            perPage: Number,
            showPerPageSelect:{
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                val: 0
            };
        },
        created() {
            this.val = this.perPage;
        },
        updated() {
            this.sendToParent();
        },
        methods:{
            sendToParent(){
                this.$emit('method', this.val);
            }
        }
    };
</script>

<style scoped>

</style>
